import React, { useEffect, useState } from "react";
import { PromotionNaviBox } from "../../../../components/navBox/promotion-naviBox";
import { getCookie } from "../../../../util/cookie/cookies";
import { useNavigate } from "react-router-dom";
import { useGetUserContentListMutation } from "../../../../store/user/contentsApiSlice";
import Moment from "react-moment";
import VideoPlayer from "../../../../components/youtube/youtube-player";
import { useTranslation } from "react-i18next";
interface ParamData {contentsType : any, lang : string, page : any, size : number, keyword : string, sortOrder : string, sortColumn : string}
export const PromotionVideo = () => {
    const {t} = useTranslation() 
    const lang = getCookie('HYUNDAILANG')
    const navigate = useNavigate()
    const [param , setParam] = useState<ParamData>({contentsType : 4, lang : lang === 'kr' ? 'KR' : 'EN', page : 1, size : 99, keyword : '', sortOrder : 'desc', sortColumn : 'date'})
    const [getUserContentListApi] = useGetUserContentListMutation()
    const [data, setData] = useState<any>([])
    const getList = async() => {
        const result : any = await getUserContentListApi(param)
        if(result.data.result === true){
            setData(result.data.list)
        }
    }
    useEffect(()=>{
        if(lang === 'kr'){setParam((prev)=>({...prev, lang : 'KR'}))}
        else {setParam((prev)=>({...prev, lang : 'EN'}))}
    }, [lang])
    useEffect(()=>{getList()}, [param.lang])
    return(
        <>
        <div className="contentBox">
            <div>
                <div className="left stickyBox">
                    <h3>
                        <span>{t("prcenter_news_1")}</span>
                        {t("prcenter_news_6")}
                    </h3>
                    <PromotionNaviBox/>
                </div>
                <div className="right">
                    <ul>
                        {data?.map((list:any, index : number)=>(
                        <li key={index}>
                            <div className="videoBox">
                                {/* <img src="/assets/images/press_release_list.png" alt="보도자료 리스트 썸네일"/> */}
                                <div>
                                    <VideoPlayer url={list?.prom_video_url_kr}/>
                                </div>
                            </div>
                            <div className="txtBox">
                                <span><Moment format="YYYY.MM">{list?.prom_mdate}</Moment></span>
                                <span>{lang === 'kr' ? list?.prom_subject_kr : list?.prom_subject_en}</span>
                            </div>
                        </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
        </>
    )
}